import {
  CATEGORIES,
  type MEDIA_TYPE,
  type PublicationType,
} from "../PublicationList_left";
import reports_en from "./reports-en.json";
import reports_tc from "./reports-tc.json";
import legislative_en from "./legco-paper-en.json";
import legislative_tc from "./legco-paper-tc.json";
import legislative_sc from "./legco-paper-sc.json";
import { Language } from "../../context";
import { t2sWithCharMap } from "../../utils";

/**
 * Transforms raw JSON entries into standardized PublicationType objects.
 * Optionally converts Traditional Chinese titles to Simplified Chinese.
 *
 * @param jsonData - The raw JSON array from any language version
 * @param t2s - Optional flag to convert traditional Chinese to simplified
 * @returns An array of normalized PublicationType objects
 */

const processJson = (jsonData: any[], t2s?: boolean): PublicationType[] => {
  return jsonData?.map((item) => ({
    title: t2s ? t2sWithCharMap(item?.title ?? "") : item?.title ?? "",
    date: item?.date ?? "",
    link: item?.url ?? "",
    mediaType: item?.type as MEDIA_TYPE,
    yearRange: item?.yearRange ?? [0, 0],
    category: [CATEGORIES.REPORTS],
  }));
};
// Process annual reports by language
const report_pages_en = processJson(reports_en);
const report_pages_tc = processJson(reports_tc);
const report_pages_sc = processJson(reports_tc, true); // Convert to simplified

// Process legislative council papers by language
const legislative_pages_en = processJson(legislative_en);
const legislative_pages_tc = processJson(legislative_tc);
const legislative_pages_sc = processJson(legislative_sc);

/**
 * Maps each supported language to its corresponding list of Legislative Council papers.
 */
export const legislativePagesLanguageMap: Record<Language, PublicationType[]> =
  {
    [Language.EN]: legislative_pages_en,
    [Language.TC]: legislative_pages_tc,
    [Language.SC]: legislative_pages_sc,
  };

/**
 * Maps each supported language to its corresponding list of annual reports.
 */
export const reportsLanguageMap: Record<Language, PublicationType[]> = {
  [Language.EN]: report_pages_en,
  [Language.TC]: report_pages_tc,
  [Language.SC]: report_pages_sc,
};
